(function () {
  function getActiveGender(genderSelect) {
    var opt = genderSelect.options[genderSelect.selectedIndex];
    return opt && opt.dataset.gender ? opt.dataset.gender : '';
  }

  function categoryTargetId(value) {
    if (!value) return '';
    return value.charAt(0) === '#' ? value.slice(1) : value;
  }

  /** Maps dropdown / legacy hash ids to the section element id in the markup. */
  function resolveSectionId(id) {
    var aliases = {
      'wayfarer-pants-bis': 'wayfarer-pants',
      'out-bags&packs': 'out-bags-packs'
    };
    return aliases[id] || id;
  }

  function findSection(root, sectionId) {
    var resolved = resolveSectionId(sectionId);
    var el = document.getElementById(resolved);
    if (!el || !root.contains(el)) return null;
    return el;
  }

  function syncGenderFromPage(root, genderSelect) {
    var pageGender = root.dataset.pageGender;
    if (!pageGender) return;

    Array.from(genderSelect.options).forEach(function (opt, index) {
      if (opt.dataset.gender === pageGender) {
        genderSelect.selectedIndex = index;
      }
    });
  }

  function restructureSection(section) {
    var row = section.querySelector('.row');
    if (!row) return;

    var sizeRow = row.querySelector('.size-row');
    if (!sizeRow || sizeRow.dataset.layoutReady === 'true') return;

    var tableCol = null;
    var measureCol = null;

    sizeRow.querySelectorAll(':scope > div').forEach(function (col) {
      if (col.querySelector('table')) tableCol = col;
      else if (col.querySelector('img')) measureCol = col;
    });

    if (!tableCol || !measureCol) return;

    var h3 = row.querySelector('h3');
    var intro = row.querySelector('p[style*="text-align:center"]');

    if (h3) {
      measureCol.insertBefore(h3, measureCol.firstChild);
    }
    if (intro) {
      intro.classList.add('size-chart-section__intro');
      measureCol.insertBefore(intro, measureCol.querySelector('img'));
    }

    row.querySelectorAll(':scope > br').forEach(function (br) {
      br.remove();
    });

    tableCol.classList.add('size-chart-section__table');
    measureCol.classList.add('size-chart-section__measure');

    var divider = document.createElement('hr');
    divider.className = 'size-chart-section__divider';

    sizeRow.insertBefore(tableCol, sizeRow.firstChild);
    sizeRow.insertBefore(divider, measureCol);

    sizeRow.dataset.layoutReady = 'true';
  }

  function firstVisibleCategoryOption(categorySelect) {
    return Array.from(categorySelect.options).find(function (opt) {
      return opt.value && !opt.hidden && !opt.disabled;
    });
  }

  function selectFirstCategory(categorySelect) {
    var first = firstVisibleCategoryOption(categorySelect);
    if (first) categorySelect.value = first.value;
  }

  function filterCategoryOptions(genderSelect, categorySelect) {
    var gender = getActiveGender(genderSelect);

    Array.from(categorySelect.options).forEach(function (opt) {
      if (!opt.value) return;
      var allowed = (opt.dataset.gender || '').split('|');
      opt.hidden = !gender || allowed.indexOf(gender) === -1;
    });

    var selected = categorySelect.options[categorySelect.selectedIndex];
    if (!selected || !selected.value || selected.hidden) {
      selectFirstCategory(categorySelect);
    }
  }

  function updateVisibleSection(root, genderSelect, categorySelect) {
    var gender = getActiveGender(genderSelect);
    var targetId = resolveSectionId(categoryTargetId(categorySelect.value));
    var showChart = Boolean(gender && targetId);

    root.querySelectorAll('.size-chart-section').forEach(function (section) {
      section.hidden = !showChart || section.id !== targetId;
    });
  }

  function navigateToGenderPage(url) {
    if (!url) return;

    var targetPath;
    try {
      targetPath = new URL(url, window.location.origin).pathname;
    } catch (e) {
      window.location.assign(url);
      return;
    }

    if (targetPath === window.location.pathname) return;
    window.location.assign(url);
  }

  function initSizeChartRoot(root) {
    if (root.dataset.sizeChartInit === 'true') return;

    var genderSelect = root.querySelector('[data-size-chart-gender]');
    var categorySelect = root.querySelector('[data-size-chart-category]');
    if (!genderSelect || !categorySelect) return;

    root.dataset.sizeChartInit = 'true';

    syncGenderFromPage(root, genderSelect);

    root.querySelectorAll('.container[id]').forEach(function (section) {
      if (section.closest('.size-chart-filters')) return;
      if (section.closest('.selection-container')) return;
      section.classList.add('size-chart-section');
      restructureSection(section);
      section.hidden = true;
    });

    root.querySelectorAll(':scope > hr').forEach(function (hr) {
      hr.hidden = true;
    });

    filterCategoryOptions(genderSelect, categorySelect);

    var hashId = resolveSectionId(categoryTargetId(window.location.hash));
    if (hashId && findSection(root, hashId)) {
      var hashOpt = Array.from(categorySelect.options).find(function (opt) {
        return resolveSectionId(categoryTargetId(opt.value)) === hashId && !opt.hidden;
      });
      if (hashOpt) categorySelect.value = hashOpt.value;
    } else {
      selectFirstCategory(categorySelect);
    }

    updateVisibleSection(root, genderSelect, categorySelect);

    genderSelect.addEventListener('change', function () {
      var opt = this.options[this.selectedIndex];
      if (!opt || !opt.value) {
        filterCategoryOptions(genderSelect, categorySelect);
        selectFirstCategory(categorySelect);
        updateVisibleSection(root, genderSelect, categorySelect);
        return;
      }
      filterCategoryOptions(genderSelect, categorySelect);
      navigateToGenderPage(opt.value);
    });

    categorySelect.addEventListener('change', function () {
      var targetId = resolveSectionId(categoryTargetId(this.value));
      if (targetId) {
        history.replaceState(null, '', '#' + targetId);
      } else {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      updateVisibleSection(root, genderSelect, categorySelect);
    });
  }

  function initSizeChartPage() {
    document.querySelectorAll('.size-chart-page').forEach(initSizeChartRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChartPage);
  } else {
    initSizeChartPage();
  }
})();
